<template>
  <div>
    <div
      v-if="!isLoading"
      class="w-full"
    >
      <!-- Payment Step Two First Time Through -->
      <!-- Payment Type: Factoring -->
      <div
        v-if="paymentType === 'factoring'"
        class="text-left"
      >
        <div>
          <div v-if="data?.factor && !editFactor">
            <p class="mb-8 mt-4 text-dark-gray sm:mt-2 sm:text-lg">
              Please confirm your factoring company below.
            </p>
            <p class="rounded-1 mb-2 w-full border-b-2 pb-1 text-body-color">
              Factoring Company Details
            </p>
            <div>
              <label class="text-2xs font-bold uppercase text-gray-over-dark">
                Factoring Company Name
              </label>
              <p>{{ data?.factor?.name || '-' }}</p>
            </div>
            <div>
              <label class="text-2xs font-bold uppercase text-gray-over-dark">
                Phone #
              </label>
              <p>{{ data?.factor?.phone || '-' }}</p>
            </div>
            <div>
              <label class="text-2xs font-bold uppercase text-gray-over-dark">
                Email
              </label>
              <p>{{ data?.factor?.email_address || '-' }}</p>
            </div>
          </div>
          <div v-else-if="latestFactor?.id > 0 && !editFactor">
            <p class="mb-8 mt-4 text-dark-gray sm:mt-2 sm:text-lg">
              Please confirm your factoring company below.
            </p>
            <p class="rounded-1 mb-2 w-full border-b-2 pb-1 text-body-color">
              Factoring Company Details
            </p>
            <div>
              <label class="text-2xs font-bold uppercase text-gray-over-dark">
                Factoring Company Name
              </label>
              <p>{{ latestFactor?.name || '-' }}</p>
            </div>
            <div>
              <label class="text-2xs font-bold uppercase text-gray-over-dark">
                Phone #
              </label>
              <p>{{ latestFactor?.phone || '-' }}</p>
            </div>
            <div>
              <label class="text-2xs font-bold uppercase text-gray-over-dark">
                Email
              </label>
              <p>{{ latestFactor?.email_address || '-' }}</p>
            </div>
          </div>
          <div
            v-else
            class="text-left"
          >
            <factor-form
              :data="data"
              :form-position="formPosition"
              :step-name="stepName"
            />
          </div>
        </div>
      </div>
      <div
        v-else-if="shouldDisplayTPay"
        class="text-left"
      >
        <!-- Payment Method Type TPay -->
        <div>
          <triumph-pay :payment="payment" />
        </div>
      </div>
      <!-- ACH/Check -->
      <div
        v-else
        class="text-left"
      >
        <div v-if="savedPaymentMethod?.id > 0 && !editPaymentMethod">
          <div v-if="savedPaymentMethod?.is_type == 'ach'">
            <p class="mb-8 mt-4 text-dark-gray sm:mt-2 sm:text-lg">
              Please confirm your payment details.
            </p>
            <p class="rounded-1 mb-2 w-full border-b-2 pb-1 text-body-color">
              Payment Details
            </p>
            <label class="text-2xs font-bold uppercase text-gray-over-dark">
              Payment Method
            </label>
            <p class="mb-2 text-dark-gray">ACH Bank Deposit</p>
            <div class="flex flex-col sm:flex-row sm:gap-6">
              <div class="mb-2 flex flex-row">
                <div>
                  <label
                    class="text-2xs font-bold uppercase text-gray-over-dark"
                  >
                    Routing #
                  </label>
                  <p class="text-dark-gray">
                    {{
                      payment?.routing_number_id
                        ? payment?.routing_number_id?.replace(
                            /\d(?=.*\d{4})/g,
                            'X'
                          )
                        : '-'
                    }}
                  </p>
                </div>
              </div>
              <div>
                <label class="text-2xs font-bold uppercase text-gray-over-dark">
                  Account #
                </label>
                <p class="text-dark-gray">
                  {{ `XXXXXXXXX${payment?.account_last_four}` }}
                </p>
              </div>
            </div>
          </div>

          <div v-else-if="savedPaymentMethod?.is_type == 'check'">
            <h4 class="mb-8 mt-4 text-dark-gray sm:mt-2">
              Please confirm your payment details.
            </h4>
            <p class="rounded-1 mb-2 w-full border-b-2 pb-1 text-body-color">
              Payment Details
            </p>
            <label class="text-2xs font-bold uppercase text-gray-over-dark">
              Payment Method
            </label>
            <p class="mb-2 text-dark-gray">Check</p>
            <div class="flex flex-col sm:flex-row sm:gap-6">
              <div class="mb-2 flex flex-row">
                <div class="mr-6">
                  <label
                    class="text-2xs font-bold uppercase text-gray-over-dark"
                  >
                    Address 1
                  </label>
                  <p class="text-dark-gray">
                    {{ payment?.street1 }}
                  </p>
                </div>
                <div>
                  <label
                    class="text-2xs font-bold uppercase text-gray-over-dark"
                  >
                    Address 2
                  </label>
                  <p class="text-dark-gray">
                    {{ !!payment?.street2 ? payment?.street2 : '-' }}
                  </p>
                </div>
              </div>
              <div class="flex">
                <div class="mr-6">
                  <label
                    class="text-2xs font-bold uppercase text-gray-over-dark"
                  >
                    City
                  </label>
                  <p class="text-dark-gray">
                    {{ payment?.city }}
                  </p>
                </div>
                <div class="mr-6">
                  <label
                    class="text-2xs font-bold uppercase text-gray-over-dark"
                  >
                    State
                  </label>
                  <p class="text-dark-gray">
                    {{ payment?.state }}
                  </p>
                </div>
                <div class="mr-6">
                  <label
                    class="text-2xs font-bold uppercase text-gray-over-dark"
                  >
                    Zip
                  </label>
                  <p class="text-dark-gray">
                    {{ payment?.postal_code }}
                  </p>
                </div>
                <div class="mr-6">
                  <label
                    class="text-2xs font-bold uppercase text-gray-over-dark"
                  >
                    Country
                  </label>
                  <p class="text-dark-gray">
                    {{ payment?.country }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div v-else-if="savedPaymentMethod?.is_type == 'cad_eft'">
            <p class="mb-8 mt-4 text-dark-gray sm:mt-2 sm:text-lg">
              Please confirm your payment details.
            </p>
            <p class="rounded-1 mb-2 w-full border-b-2 pb-1 text-body-color">
              Payment Details
            </p>
            <label class="text-2xs font-bold uppercase text-gray-over-dark">
              Payment Method
            </label>
            <p class="mb-2 text-dark-gray">Canada EFT</p>
            <div class="flex flex-col sm:flex-row sm:gap-6">
              <div class="mb-2 flex flex-row">
                <div>
                  <label
                    class="text-2xs font-bold uppercase text-gray-over-dark"
                  >
                    Branch #
                  </label>
                  <p class="text-dark-gray">
                    {{
                      payment?.cad_eft_branch_number?.replace(
                        /\d(?=.*\d{2})/g,
                        'X'
                      )
                    }}
                  </p>
                </div>
              </div>
              <div>
                <label class="text-2xs font-bold uppercase text-gray-over-dark">
                  Bank #
                </label>
                <p class="text-dark-gray">
                  {{
                    payment?.cad_eft_bank_number?.replace(/\d(?=.*\d{2})/g, 'X')
                  }}
                </p>
              </div>
              <div>
                <label class="text-2xs font-bold uppercase text-gray-over-dark">
                  Account #
                </label>
                <p class="text-dark-gray">
                  {{
                    payment?.cad_eft_account_number?.replace(
                      /\d(?=.*\d{4})/g,
                      'X'
                    )
                  }}
                </p>
              </div>
            </div>
          </div>

          <div v-else-if="savedPaymentMethod?.is_type == 'wire'">
            <p class="mb-8 mt-4 text-dark-gray sm:mt-2 sm:text-lg">
              Please confirm your payment details.
            </p>
            <p class="rounded-1 mb-2 w-full border-b-2 pb-1 text-body-color">
              Payment Details
            </p>
            <label class="text-2xs font-bold uppercase text-gray-over-dark">
              Payment Method
            </label>
            <p class="mb-2 text-dark-gray">Wire Transfer</p>
            <div class="flex flex-col sm:flex-row sm:gap-6">
              <div class="mb-2 flex flex-row">
                <div>
                  <label
                    class="text-2xs font-bold uppercase text-gray-over-dark"
                  >
                    Routing #
                  </label>
                  <p class="text-dark-gray">
                    {{
                      payment?.routing_number_id
                        ? payment?.routing_number_id?.replace(
                            /\d(?=.*\d{4})/g,
                            'X'
                          )
                        : '-'
                    }}
                  </p>
                </div>
              </div>
              <div>
                <label class="text-2xs font-bold uppercase text-gray-over-dark">
                  Account #
                </label>
                <p class="text-dark-gray">
                  {{ `XXXXXXXXX${payment?.account_last_four}` }}
                </p>
              </div>
            </div>
          </div>

          <div v-else-if="savedPaymentMethod?.is_type == 'comcheck'">
            <p class="mb-8 mt-4 text-dark-gray sm:mt-2 sm:text-lg">
              Please confirm your payment details.
            </p>
            <p class="rounded-1 mb-2 w-full border-b-2 pb-1 text-body-color">
              Payment Details
            </p>
            <label class="text-2xs font-bold uppercase text-gray-over-dark">
              Payment Method
            </label>
            <p class="mb-2 text-dark-gray">Comchek</p>
            <div class="flex flex-col sm:flex-row sm:gap-6">
              <div class="mb-2 flex flex-row">
                <div>
                  <label
                    class="text-2xs font-bold uppercase text-gray-over-dark"
                  >
                    email address
                  </label>
                  <p class="text-dark-gray">
                    {{ payment?.email_address }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div v-else-if="savedPaymentMethod?.is_type == 'efs'">
            <p class="mb-8 mt-4 text-dark-gray sm:mt-2 sm:text-lg">
              Please confirm your payment details.
            </p>
            <p class="rounded-1 mb-2 w-full border-b-2 pb-1 text-body-color">
              Payment Details
            </p>
            <label class="text-2xs font-bold uppercase text-gray-over-dark">
              Payment Method
            </label>
            <p class="mb-2 text-dark-gray">EFS Check</p>
            <div class="flex flex-col sm:flex-row sm:gap-6">
              <div class="mb-2 flex flex-row">
                <div>
                  <label
                    class="text-2xs font-bold uppercase text-gray-over-dark"
                  >
                    Email Address
                  </label>
                  <p class="text-dark-gray">
                    {{ payment?.email_address }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div v-else-if="savedPaymentMethod?.is_type == 'echeck'">
            <h4 class="mb-8 mt-4 text-dark-gray sm:mt-2">
              Please confirm your payment details.
            </h4>
            <p class="rounded-1 mb-2 w-full border-b-2 pb-1 text-body-color">
              Payment Details
            </p>
            <label class="text-2xs font-bold uppercase text-gray-over-dark">
              Payment Method
            </label>
            <p class="mb-2 text-dark-gray">eCheck</p>
            <div class="flex flex-col sm:flex-row sm:gap-6">
              <div class="mb-2 flex flex-row">
                <div class="mr-6">
                  <label
                    class="text-2xs font-bold uppercase text-gray-over-dark"
                  >
                    Address 1
                  </label>
                  <p class="text-dark-gray">
                    {{ payment?.street1 }}
                  </p>
                </div>
                <div>
                  <label
                    class="text-2xs font-bold uppercase text-gray-over-dark"
                  >
                    Address 2
                  </label>
                  <p class="text-dark-gray">
                    {{ payment?.street2 ? payment?.street2 : '-' }}
                  </p>
                </div>
              </div>
              <div class="flex">
                <div class="mr-6">
                  <label
                    class="text-2xs font-bold uppercase text-gray-over-dark"
                  >
                    City
                  </label>
                  <p class="text-dark-gray">
                    {{ payment?.city }}
                  </p>
                </div>
                <div class="mr-6">
                  <label
                    class="text-2xs font-bold uppercase text-gray-over-dark"
                  >
                    State
                  </label>
                  <p class="text-dark-gray">
                    {{ payment?.state }}
                  </p>
                </div>
                <div class="mr-6">
                  <label
                    class="text-2xs font-bold uppercase text-gray-over-dark"
                  >
                    Zip
                  </label>
                  <p class="text-dark-gray">
                    {{ payment?.postal_code }}
                  </p>
                </div>
                <div class="mr-6">
                  <label
                    class="text-2xs font-bold uppercase text-gray-over-dark"
                  >
                    Country
                  </label>
                  <p class="text-dark-gray">
                    {{ payment?.country }}
                  </p>
                </div>
              </div>
            </div>
            <div class="mr-6 mt-5">
              <label class="text-2xs font-bold uppercase text-gray-over-dark">
                Email Address
              </label>
              <p class="text-dark-gray">
                {{ payment?.email_address }}
              </p>
            </div>
          </div>
          <div v-if="savedPaymentMethod?.is_type == 'clabe'">
            <p class="mb-8 mt-4 text-dark-gray sm:mt-2 sm:text-lg">
              Please confirm your payment details.
            </p>
            <p class="rounded-1 mb-2 w-full border-b-2 pb-1 text-body-color">
              Payment Details
            </p>
            <label class="text-2xs font-bold uppercase text-gray-over-dark">
              Payment Method
            </label>
            <p class="mb-2 text-dark-gray">CLABE Deposit</p>
            <div class="flex flex-col sm:flex-row sm:gap-6">
              <!-- <div class="flex flex-row mb-2">
                <div>
                  <label class="text-2xs font-bold uppercase text-gray-over-dark">Routing #</label>
                  <p class="text-dark-gray">{{payment?.routing_number_id ? payment?.routing_number_id?.replace(/\d(?=.*\d{4})/g,"X") : '-'}}</p>
                </div>
              </div> -->
              <div>
                <label class="text-2xs font-bold uppercase text-gray-over-dark">
                  CLABE Account #
                </label>
                <p class="text-dark-gray">
                  {{ `XXXXXXXXX${payment?.account_last_four}` }}
                </p>
              </div>
            </div>
          </div>

          <div v-if="savedPaymentMethod?.is_type == 'load_pay'">
            <p class="mb-8 mt-4 text-dark-gray sm:mt-2 sm:text-lg">
              Please confirm your payment details.
            </p>
            <p class="rounded-1 mb-2 w-full border-b-2 pb-1 text-body-color">
              Payment Details
            </p>
            <label class="text-2xs font-bold uppercase text-gray-over-dark">
              Payment Method
            </label>
            <p class="mb-2 text-dark-gray">LoadPay</p>
          </div>
        </div>
        <div
          v-else-if="carrierAPMsHaveLoaded == false"
          class="my-8"
        >
          <div
            class="flex flex-col items-center justify-center gap-3 rounded-md bg-off-white py-16"
          >
            <img
              class="-top-2px loading relative h-8 w-full"
              src="@/assets/loading-v2-yellow.svg"
              alt=""
            />
            <p class="text-dark-gray">
              Loading saved payment method details...
            </p>
          </div>
        </div>
        <div v-else-if="carrierAPMs?.length > 0 && paymentType !== 'delta'">
          <h4 class="mb-8 mt-4 text-dark-gray sm:mt-2">
            Select a saved payment method, or create a new one.
          </h4>
          <span>{{ hydrateVerification() }}</span>
          <div class="flex flex-col gap-3 md:grid md:grid-cols-2">
            <template
              v-for="(method, idx) in carrierAPMs"
              :key="`saved-method-${idx}`"
            >
              <div
                v-if="
                  method?.is_type == 'load_pay' &&
                  carrierAPMExistsForMethodType('load_pay')
                "
                class="w-full md:flex"
              >
                <round-radio-button-saved-method-with-terms
                  class="w-full"
                  :method="method"
                  value="load_pay"
                  name="source"
                  item="LoadPay"
                  term="load_pay"
                  :handle-click="
                    paymentType === 'delta'
                      ? togglePaymentSourceLoadPay
                      : togglePaymentSource
                  "
                  :checked="paymentSource === 'load_pay'"
                />
              </div>
              <div
                v-if="
                  method?.is_type == 'triumph_pay' &&
                  carrierAPMExistsForMethodType('triumph_pay')
                "
                class="w-full md:flex"
              >
                <round-radio-button-saved-method-with-terms
                  class="w-full"
                  :method="method"
                  value="triumph_pay"
                  name="source"
                  item="TriumphPay"
                  term="triumph_pay"
                  :handle-click="togglePaymentSource"
                  :checked="paymentSource === 'triumph_pay'"
                />
              </div>
              <div
                v-if="
                  method?.is_type == 'ach' &&
                  carrierAPMExistsForMethodType('ach')
                "
                class="w-full md:flex"
              >
                <round-radio-button-saved-method-with-terms
                  class="w-full"
                  :method="method"
                  value="ach"
                  name="source"
                  item="ACH Deposit"
                  term="ach_deposit"
                  :handle-click="togglePaymentSource"
                  :checked="paymentSource === 'ach'"
                />
              </div>
              <div
                v-if="
                  method?.is_type == 'check' &&
                  carrierAPMExistsForMethodType('check')
                "
                class="w-full md:flex"
              >
                <round-radio-button-saved-method-with-terms
                  class="w-full"
                  :method="method"
                  value="check"
                  item="Check"
                  name="source"
                  :handle-click="togglePaymentSource"
                  :checked="paymentSource === 'check'"
                />
              </div>
              <div
                v-if="
                  method?.is_type == 'wire' &&
                  carrierAPMExistsForMethodType('wire')
                "
                class="w-full md:flex"
              >
                <round-radio-button-saved-method-with-terms
                  class="w-full"
                  :method="method"
                  value="wire"
                  item="Wire Transfer"
                  name="wire_transfer"
                  :handle-click="togglePaymentSource"
                  :checked="paymentSource === 'wire'"
                />
              </div>
              <div
                v-if="
                  method?.is_type == 'cad_eft' &&
                  carrierAPMExistsForMethodType('cad_eft')
                "
                class="w-full md:flex"
              >
                <round-radio-button-saved-method-with-terms
                  class="w-full"
                  :method="method"
                  value="cad_eft"
                  item="Canada EFT"
                  name="canada_eft"
                  :handle-click="togglePaymentSource"
                  :checked="paymentSource === 'cad_eft'"
                />
              </div>
              <div
                v-if="
                  method?.is_type == 'comcheck' &&
                  carrierAPMExistsForMethodType('comcheck')
                "
                class="w-full md:flex"
              >
                <round-radio-button-saved-method-with-terms
                  class="w-full"
                  :method="method"
                  value="comcheck"
                  item="Comchek"
                  name="com_check"
                  :handle-click="togglePaymentSource"
                  :checked="paymentSource === 'comcheck'"
                />
              </div>
              <div
                v-if="
                  method?.is_type == 'efs' &&
                  carrierAPMExistsForMethodType('efs')
                "
                class="w-full md:flex"
              >
                <round-radio-button-saved-method-with-terms
                  class="w-full"
                  :method="method"
                  value="efs"
                  item="EFS Check"
                  name="efs"
                  :handle-click="togglePaymentSource"
                  :checked="paymentSource === 'efs'"
                />
              </div>
              <div
                v-if="
                  method?.is_type == 'echeck' &&
                  carrierAPMExistsForMethodType('echeck')
                "
                class="w-full md:flex"
              >
                <round-radio-button-saved-method-with-terms
                  class="w-full"
                  :method="method"
                  value="echeck"
                  item="eCheck"
                  name="e_check"
                  :handle-click="togglePaymentSource"
                  :checked="paymentSource === 'echeck'"
                />
              </div>
              <div
                v-if="
                  method?.is_type == 'clabe' &&
                  carrierAPMExistsForMethodType('clabe')
                "
                class="w-full md:flex"
              >
                <round-radio-button-saved-method-with-terms
                  class="w-full"
                  :method="method"
                  value="clabe"
                  item="CLABE"
                  name="clabe"
                  :handle-click="togglePaymentSource"
                  :checked="paymentSource === 'clabe'"
                />
              </div>
            </template>
          </div>
          <div
            v-if="paymentType !== 'delta'"
            class="mt-6"
          >
            <button
              type="button"
              class="flex cursor-pointer items-center gap-1 rounded-md border border-body-color py-2 pl-1 pr-2 text-sm text-body-color hover:bg-off-white"
              @click="handleAddNewPaymentMethod()"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="h-5 w-5"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M12 6v12m6-6H6"
                />
              </svg>
              <span>Add Payment Method</span>
            </button>
          </div>
        </div>

        <div v-else>
          <!-- Create new payment method -->
          <h4
            class="mt-4 text-dark-gray sm:mt-2"
            :class="[displayLoadPay ? '' : 'mb-8']"
          >
            Select a Payment Method
          </h4>
          <span
            v-if="displayLoadPay"
            class="text-sm font-normal text-neutral-subtlest"
            :class="[displayLoadPay ? 'mb-5' : '']"
          >
            {{
              paymentType === 'delta'
                ? 'Choose from the following 2 options'
                : 'Choose from the following options'
            }}
          </span>
          <section
            v-if="displayLoadPay"
            class="mb-3 mt-5 flex flex-col gap-3"
          >
            <round-radio-button-terms
              class="w-full"
              value="load_pay"
              name="new_payment_method_type"
              item="Load Pay"
              term="load_pay"
              :highlight-box="true"
              highlight-text="Recommended"
              :always-highlight="
                !newPaymentMethodType || newPaymentMethodType === 'load_pay'
              "
              :handle-click="updateNewPaymentMethodLoadPay"
              :checked="newPaymentMethodType === 'load_pay'"
            />
            <round-radio-button-terms
              v-if="paymentType === 'delta'"
              class="w-full"
              value=""
              name=""
              item="I prefer my standard payment method"
              term=""
              :handle-click="updateNewPaymentMethodLoadPay"
              :checked="newPaymentMethodType === ''"
            />
            <p
              v-if="displayStandard"
              class="mt-3 text-neutral-subtle"
            >
              {{
                paymentType === 'delta' ? 'Standard' : 'Other Payment Methods'
              }}
            </p>
          </section>
          <span>{{ hydrateVerification() }}</span>
          <div class="flex flex-col gap-3 md:grid md:grid-cols-2">
            <div
              v-if="opTerm?.allowed_payment_methods?.includes('ach')"
              class="w-full md:flex"
            >
              <round-radio-button-terms
                class="w-full"
                value="ach"
                name="new_payment_method_type"
                item="ACH Deposit"
                term="ach_deposit"
                :handle-click="updateNewPaymentMethodType"
                :checked="newPaymentMethodType === 'ach'"
              />
            </div>
            <div
              v-if="opTerm?.allowed_payment_methods?.includes('check')"
              class="w-full md:flex"
            >
              <round-radio-button
                class="w-full"
                value="check"
                item="Check"
                name="new_payment_method_type"
                :handle-click="updateNewPaymentMethodType"
                :checked="newPaymentMethodType === 'check'"
              />
            </div>
            <div
              v-if="opTerm?.allowed_payment_methods?.includes('wire')"
              class="w-full md:flex"
            >
              <round-radio-button
                class="w-full"
                value="wire"
                item="Wire Transfer"
                name="new_payment_method_type"
                :handle-click="updateNewPaymentMethodType"
                :checked="newPaymentMethodType === 'wire'"
              />
            </div>
            <div
              v-if="opTerm?.allowed_payment_methods?.includes('cad_eft')"
              class="w-full md:flex"
            >
              <round-radio-button
                class="w-full"
                value="cad_eft"
                item="Canada EFT"
                name="new_payment_method_type"
                :handle-click="updateNewPaymentMethodType"
                :checked="newPaymentMethodType === 'cad_eft'"
              />
            </div>
            <div
              v-if="opTerm?.allowed_payment_methods?.includes('comcheck')"
              class="w-full md:flex"
            >
              <round-radio-button
                class="w-full"
                value="comcheck"
                item="Comchek"
                name="new_payment_method_type"
                :handle-click="updateNewPaymentMethodType"
                :checked="newPaymentMethodType === 'comcheck'"
              />
            </div>
            <div
              v-if="opTerm?.allowed_payment_methods?.includes('efs')"
              class="w-full md:flex"
            >
              <round-radio-button
                class="w-full"
                value="efs"
                item="EFS Check"
                name="new_payment_method_type"
                :handle-click="updateNewPaymentMethodType"
                :checked="newPaymentMethodType === 'efs'"
              />
            </div>
            <div
              v-if="opTerm?.allowed_payment_methods?.includes('echeck')"
              class="w-full md:flex"
            >
              <round-radio-button
                class="w-full"
                value="echeck"
                item="eCheck"
                name="new_payment_method_type"
                :handle-click="updateNewPaymentMethodType"
                :checked="newPaymentMethodType === 'echeck'"
              />
            </div>
            <div
              v-if="opTerm?.allowed_payment_methods?.includes('clabe')"
              class="w-full md:flex"
            >
              <round-radio-button
                class="w-full"
                value="clabe"
                item="CLABE"
                name="new_payment_method_type"
                :handle-click="updateNewPaymentMethodType"
                :checked="newPaymentMethodType === 'clabe'"
              />
            </div>
          </div>
          <section
            v-if="displayLoadPay"
            class="mt-4 text-left font-normal"
          >
            <p class="text-1xs text-yellow-500">Privacy Policy</p>
            <p class="text-1xs text-neutral-subtle">
              LoadPay is a product offering of TBK Bank, SSB, Member FDIC. The
              LoadPay debit card is issued by TBK Bank, SSB pursuant to a
              license from Mastercard.
            </p>
          </section>
        </div>
      </div>
      <new-payment-method-type-modal
        v-if="showNewPaymentMethodModal"
        :visible="showNewPaymentMethodModal"
        :allowed-payment-methods="opTerm?.allowed_payment_methods"
        :carrier-active-payment-methods="carrierActivePaymentMethods"
        :term-name="opTerm?.name"
        @close="handleCloseNewPaymentMethodModal"
        @add="handleAddNewPaymentMethodType"
      />
    </div>
    <div
      v-else
      class="my-8"
    >
      <div
        class="flex flex-col items-center justify-center gap-3 rounded-md bg-off-white py-16"
      >
        <img
          class="-top-2px loading relative h-8 w-full"
          src="@/assets/loading-v2-yellow.svg"
          alt=""
        />
        <p class="text-dark-gray">Loading payment details...</p>
      </div>
    </div>
    <form-navigation-buttons
      v-if="!isNavigationDisabled"
      :enabled="!isNavigationDisabled"
      :component-identifier="componentIdentifier"
      :buttons-to-display="buttonsToDisplay"
      :is-button-disabled="isButtonDisabled"
      @next="handleNext"
      @back="handleBack"
      @edit="handleEdit"
    />
  </div>
</template>

<script>
import FormNavigationButtons from '@/components/FormNavigationButtons.vue';
import { useFormRouter } from '@/composables/formRouter';
import { useStore } from 'vuex';
import { computed, watch, ref } from 'vue';
import RoundRadioButton from '../../RoundRadioButton.vue';
import RoundRadioButtonTerms from '@/components/RoundRadioButtonTerms.vue';
// import RoundRadioButtonSavedMethod from "@/components/RoundRadioButtonSavedMethod.vue"
import RoundRadioButtonSavedMethodWithTerms from '@/components/RoundRadioButtonSavedMethodWithTerms.vue';
import FactorForm from './FactorForm.vue';
import TriumphPay from './TriumphPay.vue';
import NewPaymentMethodTypeModal from '@/components/modals/NewPaymentMethodTypeModal.vue';
import { useToast } from 'vue-toast-notification';
import { formatErrorResponse } from '@/common/handleServerResponse';
export default {
  name: 'PaymentStepTwo',
  components: {
    FormNavigationButtons,
    'round-radio-button': RoundRadioButton,
    'round-radio-button-terms': RoundRadioButtonTerms,
    'factor-form': FactorForm,
    'triumph-pay': TriumphPay,
    // RoundRadioButtonSavedMethod,
    RoundRadioButtonSavedMethodWithTerms,
    NewPaymentMethodTypeModal,
  },
  props: {
    data: Object,
    updateField: Function,
    formPosition: Number,
    title: String,
    nextStep: Function,
    skipStep: Function,
    screenSize: String,
  },
  setup() {
    const store = useStore();
    const toast = useToast();
    const componentIdentifier = 'Payment-2';
    const formRouter = useFormRouter(componentIdentifier);
    const isNavigationDisabled = computed(() => formRouter.isDisabled.value);
    const firstTime = computed(
      () =>
        store.state.firstTime?.[
          formRouter.componentStep.value?.firstTimeIdentifier
        ]
    );
    const paymentType = computed(() => store.state.payments?.payment_type);
    const savedPaymentTerm = computed(
      () => store.state.payments?.saved_payment_term
    );
    const latestFactor = computed(() =>
      Array.isArray(store.state.factors?.latestFactor)
        ? store.state.factors?.latestFactor?.[0]
        : store.state.factors?.latestFactor
    );
    const isLoading = ref(false);

    // const displayed_payment_method = computed(() => store.state.payments?.displayed_payment_method);
    // const hasLatestFactor = computed(() => store.state.factors?.latestFactor?.length > 0);
    // const carrierHasExistingTriumphPayPaymentMethod = computed(() => store.state.payments.activePaymentMethods?.some(payment => payment.is_type === 'triumph_pay'));
    const isTriumphPayAllowedByPaymentTerms = computed(() =>
      store.state.payments?.payment_terms?.some((term) =>
        term?.allowed_payment_methods?.includes('triumph_pay')
      )
    );
    const isLoadPayAllowedByPaymentTerms = computed(() =>
      store.state.payments?.payment_terms?.some((term) =>
        term?.allowed_payment_methods?.includes('load_pay')
      )
    );
    const displayLoadPay = computed(() => {
      return isLoadPayAllowedByPaymentTerms.value && shouldEnableCHRFlow.value;
    });
    const savedPaymentMethod = computed(
      () => store.state.payments?.saved_payment_method
    );
    // const hasSavedPaymentMethod = computed(() => savedPaymentMethod.value?.id > 0);
    const storedPaymentMethods = computed(
      () => store.state.payments?.activePaymentMethods
    );
    const hasStoredPaymentMethodForPaymentSource = computed(() =>
      storedPaymentMethods.value?.some(
        (payment) => payment?.is_type === store.state.payments?.payment_source
      )
    );
    const carrierHasTriumphPayPaymentMethod = computed(() =>
      store.state.payments?.activePaymentMethods?.some(
        (payment) => payment?.is_type === 'triumph_pay'
      )
    );
    const isTriumphPayAllowedForPaymentSource = computed(() =>
      store.state.payments?.activePaymentMethods?.some(
        (payment) =>
          payment?.triumph_pay_wallet_destination_type ===
          store.state.payments?.payment_source
      )
    );
    const paymentMethodId = computed(() =>
      store.state.payments.activePaymentMethods?.find(
        (payment) => payment?.is_type === store.state.payments.payment_source
      )
    );
    const isEmpty = (obj) => {
      if (obj === undefined || obj === null || Object.keys(obj).length === 0) {
        return true;
      } else {
        return false;
      }
    };
    const paymentBody = computed(() => store.state.payments?.payment_body);
    const onboardingPacketId = computed(() => store.state.onboardingPacket?.id);
    const factorId = computed(
      () => store.state.carriers.carrierData?.factor?.id
    );
    const paymentTermId = computed(() => store.state.payments?.payment_term_id);
    const isPaymentMethodAllowedSetup = (requestedPaymentMethod) => {
      let terms = [...(store.state.payments?.payment_terms ?? [])];
      let termsNonFactoring = terms.filter(
        (term) => term?.is_type !== 'factoring'
      );
      return termsNonFactoring.some((term) =>
        term?.allowed_payment_methods?.includes(requestedPaymentMethod)
      );
    };
    const renderedPayment = computed(() =>
      Array.isArray(store.state.payments.rendered_payment)
        ? store.state.payments.rendered_payment?.[0]
        : store.state.payments.rendered_payment
    );

    const getCarrierAPMs = async (payment_term) => {
      await store.dispatch('payments/getCarrierAPMsByTerm', payment_term);
    };

    const opTerm = ref(null);

    watch(
      () => store.state.payments.saved_payment_term,
      (val) => {
        if (val?.id > 0) {
          opTerm.value = val;
          getCarrierAPMs(val);
        }
      },
      { deep: true, immediate: true }
    );

    const stepName = computed(
      () => store.state.formRoutes?.activeStepIdentifier
    );
    const onboarding_id = computed(() => store.state.carriers?.carrierData?.id);
    const carrierActivePaymentMethods = computed(
      () => store.state.payments?.activePaymentMethods
    );
    const editFactor = computed(() => store.state.payments.edit.factor);
    const editPaymentMethod = computed(
      () => store.state.payments.edit.payment_method
    );
    const carrierClickedEditTPayMethod = computed(
      () => store.state.payments?.triumph_pay_declined
    );
    const latestTriumphPayPaymentMethod = computed(
      () => store.state.payments.latest_triumph_pay_payment_method
    );
    const shouldDisplayTPay = computed(
      () =>
        savedPaymentMethod.value?.is_type == 'triumph_pay' ||
        (latestTriumphPayPaymentMethod.value?.id > 0 &&
          opTerm.value?.allowed_payment_methods?.includes('triumph_pay') &&
          !carrierClickedEditTPayMethod.value)
    );
    const carrierAPMs = computed(() => store.state.payments?.carrierAPMs);
    const carrierAPMsHaveLoaded = computed(
      () => store.state.payments?.carrierAPMsHaveLoaded
    );

    const carrierAPMExistsForMethodType = (methodType) => {
      if (carrierAPMs.value?.length > 0) {
        return carrierAPMs.value?.some((apm) => apm?.is_type === methodType);
      } else {
        return false;
      }
    };

    // buttonChecks: Checks for determining which buttons to show in FormNavigationButtons
    const buttonCheck1 = computed(
      () =>
        (store.state.payments?.payment_type === 'factoring' &&
          latestFactor.value?.id > 0 &&
          !store.state.payments.edit.factor) ||
        store.state.payments?.saved_payment_term?.is_type === 'factoring' ||
        !!store.state.carriers?.carrierData?.factor
    );
    const buttonCheck2 = computed(() => shouldDisplayTPay.value);
    const buttonCheck3 = computed(
      () =>
        !store.state.payments.edit.payment_method &&
        savedPaymentMethod.value?.id > 0
    );
    // const buttonCheck2 = computed(() => (firstTime.value && !hasLatestFactor.value) || (store.state.payments?.edit?.check_ach || store.state.payments?.edit?.factor));
    // const buttonCheck2 = computed(() => (firstTime.value && !hasLatestFactor.value) || store.state.payments?.edit?.factor || (store.state.payments?.payment_type === 'factoring' && !factorId.value));
    // const buttonCheck3 = computed(() => store.state.payments?.payment_type !== 'factoring' && carrierHasExistingTriumphPayPaymentMethod.value && store.state.payments?.payment_source !== 'triumph_pay');
    // const buttonCheck4 = computed(() => carrierHasExistingTriumphPayPaymentMethod.value && isTriumphPayAllowedByPaymentTerms.value && store.state.payments?.payment_type !== 'factoring');
    // const buttonCheck5 = computed(() => !hasSavedPaymentMethod.value );

    const buttonsToDisplay = computed(() => {
      if (buttonCheck1.value || buttonCheck2.value || buttonCheck3.value)
        return 'continue-edit';
      return 'continue-save';
      // if (buttonCheck2.value) return 'continue-save';
      // if (buttonCheck3.value || buttonCheck4.value) return 'continue-edit';
      // if (buttonCheck5.value) return 'continue-save';
      // if (firstTime.value) return 'continue-save';
      // return 'continue-edit';
    });
    const isButtonDisabled = false;

    const isEmptyObj = (obj) => !obj || Object.keys(obj).length === 0;

    const isPaymentMethodParamEmpty = (paymentMethod) =>
      !paymentMethod ||
      !paymentMethod.payment_method ||
      isEmptyObj(paymentMethod.payment_method);

    const createPaymentMethod = async (paymentMethod, onboardingPacketId) => {
      if (isPaymentMethodParamEmpty(paymentMethod)) {
        toast?.open({
          message:
            'Something went wrong with your request. Please return to the payment method selection screen and try again',
          position: 'top-right',
          duration: 5000,
        });
        return false;
      }

      try {
        const paymentResponse = await store.dispatch(
          'payments/createPaymentMethod',
          {
            paymentMethod,
            onboardingPacketId,
          }
        );

        await store.dispatch(
          'payments/getActivePaymentMethods',
          onboardingPacketId
        );

        if (
          paymentResponse?.status === 422 &&
          paymentResponse?.data?.payment_method?.[0] ===
            'verification required for adding additional payment methods'
        ) {
          store.commit(
            'addFormDebugMessage',
            `${componentIdentifier}: User attempted to create a payment method but received 'verification required for adding additional payment methods' error, redirecting to Payment-4 for verification`
          );
          await formRouter.moveToStepByIdentifier('Payment-4');
        } else if ([401, 403, 404, 422].includes(paymentResponse?.status)) {
          throw new Error('An error has occurred');
        }

        return true;
      } catch (error) {
        const response = error?.response || null;

        toast?.open({
          message: response
            ? formatErrorResponse(response)
            : 'An unexpected error occurred.',
          position: 'top-right',
          duration: 5000,
        });

        return false;
      }
    };

    watch([stepName, buttonsToDisplay], ([val1, val2]) => {
      if (val1 == 'Payment-1' && val2 == 'continue-edit') {
        store.commit('toggleDisabledButton', {
          bool: false,
          source: 'PaymentStepTwo #3',
        });
      }
    });

    // checkHelpers: Not directly checked but are used in calculating other checks
    const checkHelper1 = computed(
      () =>
        storedPaymentMethods.value?.some(
          (payment) => payment?.is_type === store.state.payments?.payment_source
        ) &&
        store.state.payments.secondVerificationPayment === false &&
        store.state.payments.payment_type !== 'factoring'
    );

    // nextChecks: Checks to be reviewed when the user clicks the Continue button (but before any store.state.formRoutes.activeStep changes)
    const nextCheck1 = computed(
      () =>
        isTriumphPayAllowedByPaymentTerms.value &&
        carrierHasTriumphPayPaymentMethod.value &&
        isTriumphPayAllowedForPaymentSource.value &&
        store.state.payments.secondVerificationPayment === false &&
        store.state.payments?.payment_source === 'triumph_pay' &&
        store.state.payments.payment_type !== 'factoring'
    );
    const nextCheck2 = computed(
      () => checkHelper1.value && store.state.payments?.edit?.check_ach == true
    );
    const nextCheck3 = computed(
      () =>
        checkHelper1.value &&
        store.state.payments?.edit?.check_ach !== true &&
        hasStoredPaymentMethodForPaymentSource.value
    );
    const nextCheck4 = computed(
      () =>
        (!isTriumphPayAllowedByPaymentTerms.value ||
          (isTriumphPayAllowedByPaymentTerms.value &&
            !carrierHasTriumphPayPaymentMethod.value)) &&
        store.state.payments.payment_type !== 'factoring' &&
        hasStoredPaymentMethodForPaymentSource.value
    );
    const nextCheck5 = computed(
      () => store.state.payments.payment_type === 'factoring'
    );
    const nextCheck6 = computed(
      () =>
        (store.state.payments.payment_type === 'factoring' &&
          !!factorId.value &&
          !store.state.payments.edit.factor) ||
        (store.state.payments.payment_type !== 'factoring' &&
          !!store.state.carriers.carrierData?.payment_method &&
          !store.state.payments.edit.payment_method) ||
        store.state.payments.rendered_payment?.[0]?.is_type === 'triumph_pay' ||
        store.state.payments.rendered_payment?.is_type === 'triumph_pay'
    );
    const shouldEnableCHRFlow = computed(
      () => store.getters.shouldEnableCHRFlow && !store.getters.isForeignCarrier
    );
    const nextCheck7 = computed(
      () =>
        store.state.payments.payment_source == 'load_pay' &&
        shouldEnableCHRFlow.value &&
        store.state.payments.payment_type !== 'factoring'
    );

    const nextCheck8 = computed(
      () =>
        (store.state.payments.payment_type === 'delta' ||
          store.state.payments.payment_source == 'load_pay') &&
        shouldEnableCHRFlow.value &&
        store.state.payments.payment_type !== 'factoring'
    );

    const nextCheck9 = computed(() => {
      const { payment_type, payment_source } = store.state.payments;

      const isDeltaWithNoSource =
        payment_type === 'delta' && payment_source.length === 0;

      const missingFactorId = store.state.payments?.payment_body == null;

      console.log('Missing factor id', missingFactorId);

      return (
        isDeltaWithNoSource && shouldEnableCHRFlow.value && missingFactorId
      );
    });

    const handleNext = async () => {
      store.commit(
        'addFormDebugMessage',
        componentIdentifier + ": 'handleNext' called"
      );
      if (isNavigationDisabled.value)
        return store.commit(
          'addFormDebugMessage',
          'ERROR: ' +
            componentIdentifier +
            ': formRouter is disabled, returning'
        );
      if (nextCheck7.value) {
        store.commit(
          'addFormDebugMessage',
          `NEXT CHECK | ${componentIdentifier}: nextCheck7 is TRUE (Payment-2 and user chose LoadPay)`
        );

        // LoadPay does not allow users to add a payment method manually,
        // so we create it automatically when the user clicks "Next".

        createPaymentMethod(
          { payment_method: { is_type: 'load_pay', is_active: true } },
          onboarding_id.value
        );

        // const step = manageUsers ? 'Payment-5' : 'Questions';
        const step = 'Payment-5';
        hitEmailTemplates();
        formRouter.moveToStepByIdentifier(step);
        return;
      }

      if (nextCheck8.value) {
        store.commit(
          'addFormDebugMessage',
          `NEXT CHECK | ${componentIdentifier}: nextCheck8 is TRUE (User chose LoadPay or Delta)`
        );
        hitEmailTemplates();
      }
      if (nextCheck9.value) {
        store.commit(
          'addFormDebugMessage',
          `NEXT CHECK | ${componentIdentifier}: nextCheck9 is TRUE (User chose LoadPay or Delta)`
        );
        console.log('Check 9');
        await store.commit('payments/setLoadPayWasDeselected', true);
        await store.dispatch('onboardingPacket/setOnboardingBody', {
          onboarding_packet: {
            payment_method_id: null,
          },
        });
        store.dispatch('onboardingPacket/getOnboardingPacketById', {
          id: store.state.onboardingPacket.onboarding_id,
        });
        return formRouter.moveToStepByIdentifier('Questions');
      }

      if (nextCheck1.value) {
        store.commit(
          'addFormDebugMessage',
          'NEXT CHECK | ' +
            componentIdentifier +
            ': nextCheck1 is TRUE (Payment-2 TriumphPay is allowed), setting edit.payment_method to false and secondVerificationPayment to true, returning without moving to next step'
        );
        store.commit('payments/setReview');
        store.commit('payments/setVerificationSecond', true);
        return;
      } else {
        store.commit(
          'addFormDebugMessage',
          'NEXT CHECK | ' +
            componentIdentifier +
            ': nextCheck1 is FALSE (Payment-2 TriumphPay is not allowed)'
        );
      }

      if (nextCheck2.value) {
        store.commit(
          'addFormDebugMessage',
          'NEXT CHECK | ' +
            componentIdentifier +
            ': nextCheck2 is TRUE (Editing Check or ACH after verification), moving to next step'
        );
        return formRouter.moveToNextStep();
      } else {
        store.commit(
          'addFormDebugMessage',
          'NEXT CHECK | ' +
            componentIdentifier +
            ': nextCheck2 is FALSE (Not editing Check or ACH after verification)'
        );
      }

      if (nextCheck3.value) {
        store.commit(
          'addFormDebugMessage',
          'NEXT CHECK | ' +
            componentIdentifier +
            ': nextCheck3 is TRUE (Payment-2 is allowed and stored payment method matching payment_source exists), setting payment_method_id to ' +
            renderedPayment.value?.id +
            ', setting edit.payment_method to false and secondVerificationPayment to true, moving to Questions step'
        );
        // store.commit('payments/setSavedPaymentTerm', renderedPayment.value);
        store.commit('payments/setReview');
        store.commit('payments/setVerificationSecond', true);
        const body3 = {
          payment_method_id: renderedPayment.value?.id,
          factor_id: null,
        };
        store.dispatch('onboardingPacket/setOnboardingBody', {
          onboarding_packet: body3,
        });
        return formRouter.moveToStepByIdentifier('Questions');
      } else {
        store.commit(
          'addFormDebugMessage',
          'NEXT CHECK | ' +
            componentIdentifier +
            ': nextCheck3 is FALSE (Payment-2 is not allowed, or no stored payment method matching payment_source exists)'
        );
      }

      if (nextCheck4.value) {
        if (paymentMethodId.value?.id > 0) {
          store.commit(
            'addFormDebugMessage',
            'NEXT CHECK | ' +
              componentIdentifier +
              ': nextCheck4 is TRUE (Payment-2 without TriumphPay and stored payment method matching payment_source exists), setting onboardingPacketBody, setting firstTime.Payment to false, and moving to next step'
          );
          const body = {
            payment_method_id: paymentMethodId.value?.id,
            factor_id: null,
          };
          store.dispatch('onboardingPacket/setOnboardingBody', {
            onboarding_packet: body,
          });
          // updatePacket originally called here, so may need to ensure this saves;
          store.commit(
            'addFormDebugMessage',
            'QA NEEDED | ' +
              componentIdentifier +
              ": nextCheck4 TRUE logic originally called 'updatePacket' here, so we need to make sure the payment_method_id (" +
              paymentMethodId.value?.id +
              ') and factor_id (auto-set to null) saves correctly'
          );
        } else {
          store.commit(
            'addFormDebugMessage',
            'NEXT CHECK | ' +
              componentIdentifier +
              ': nextCheck4 is TRUE (Payment-2 without TriumphPay and stored payment method matching payment_source exists), not setting onboardingPacketBody (paymentMethodId not found), setting firstTime.Payment to false, and moving to Questions step'
          );
        }
        store.commit('firstTime/updateStepFirstTime', {
          step: 'Payment',
          value: false,
        });
        return formRouter.moveToStepByIdentifier('Questions');
      } else {
        store.commit(
          'addFormDebugMessage',
          'NEXT CHECK | ' +
            componentIdentifier +
            ': nextCheck4 is FALSE (Payment-2 without TriumphPay but no stored payment method matching payment_source exists)'
        );
      }

      if (nextCheck5.value) {
        store.commit(
          'addFormDebugMessage',
          'NEXT CHECK | ' +
            componentIdentifier +
            ': nextCheck5 is TRUE (Payment-2 and user chose factoring), assigning factor and payment_term (is_type of factoring) simultaneously, setting firstTime.Payment to false, and moving to Questions step'
        );
        console.log('paymentBody.value');
        console.log(paymentBody.value);
        console.log('isEmpty(paymentBody.value)');
        console.log(isEmpty(paymentBody.value));
        console.log('paymentTermId.value');
        console.log(paymentTermId.value);
        console.log('factorId.value');
        console.log(factorId.value);
        if (isEmpty(paymentBody.value)) {
          const factorIdVal = factorId.value
            ? factorId.value
            : latestFactor.value?.id;
          const factorBody = {
            payment_term_id: paymentTermId.value,
            factor_id: factorIdVal,
          };
          await store.dispatch('factors/assignFactor', {
            paymentBody: factorBody,
            onboardingPacketId: onboardingPacketId.value,
          });
        } else {
          await store.dispatch('factors/assignFactor', {
            paymentBody: paymentBody.value,
            onboardingPacketId: onboardingPacketId.value,
          });
        }
        store.commit('firstTime/updateStepFirstTime', {
          step: 'Payment',
          value: false,
        });
        return formRouter.moveToStepByIdentifier('Questions');
      } else {
        store.commit(
          'addFormDebugMessage',
          'NEXT CHECK | ' +
            componentIdentifier +
            ': nextCheck5 is FALSE (Payment-2 and user did not choose factoring)'
        );
      }

      if (nextCheck6.value) {
        store.commit(
          'addFormDebugMessage',
          'NEXT CHECK | ' +
            componentIdentifier +
            ': nextCheck5 is TRUE (Payment-2 and user did not choose factoring), assigning payment_method_id, auto-setting factor_id to null, setting firstTime.Payment to false, and moving to Questions step'
        );
        if (
          store.state.payments.rendered_payment?.[0]?.is_type ===
            'triumph_pay' &&
          isPaymentMethodAllowedSetup('triumph_pay')
        ) {
          const body6a = {
            payment_method_id: store.state.payments.rendered_payment?.[0]?.id,
            factor_id: null,
          };
          store.dispatch('onboardingPacket/setOnboardingBody', {
            onboarding_packet: body6a,
          });
          // updatePacket originally called here, so may need to ensure this saves;
          store.commit(
            'addFormDebugMessage',
            'QA NEEDED | ' +
              componentIdentifier +
              ": nextCheck6 TRUE logic originally called 'updatePacket' here, so we need to make sure the TriumphPay payment_method_id (" +
              store.state.payments.rendered_payment?.[0]?.id +
              ') and factor_id (auto-set to null) saves correctly'
          );
        } else {
          const body6b = {
            payment_method_id: paymentMethodId.value?.id,
            factor_id: null,
          };
          store.dispatch('onboardingPacket/setOnboardingBody', {
            onboarding_packet: body6b,
          });
          // updatePacket originally called here, so may need to ensure this saves;
          store.commit(
            'addFormDebugMessage',
            'QA NEEDED | ' +
              componentIdentifier +
              ": nextCheck6 TRUE logic originally called 'updatePacket' here, so we need to make sure the payment_method_id (" +
              paymentMethodId.value?.id +
              ') and factor_id (auto-set to null) saves correctly'
          );
        }
        store.commit('firstTime/updateStepFirstTime', {
          step: 'Payment',
          value: false,
        });
        return formRouter.moveToStepByIdentifier('Questions');
      } else {
        store.commit(
          'addFormDebugMessage',
          'NEXT CHECK | ' +
            componentIdentifier +
            ': nextCheck6 is FALSE (POSSIBLE ERROR AT THIS POINT - TROUBLESHOOTING NEEDED)'
        );
      }

      // Need to test whether this line below is ever reached, and if so, does it cause any issues
      formRouter.moveToNextStep();
    };

    // backChecks: Checks to be reviewed when the user clicks the Back button (but before any store.state.formRoutes.activeStep changes)
    const backCheck1 = computed(
      () => shouldDisplayTPay?.value && opTerm.value?.is_type == 'quick_pay'
    );

    const handleBack = () => {
      store.commit(
        'addFormDebugMessage',
        componentIdentifier + ": 'handleBack' called"
      );
      if (isNavigationDisabled.value)
        return console.log(
          'ERROR: ' +
            componentIdentifier +
            ': formRouter is disabled, returning'
        );

      if (backCheck1.value) {
        store.commit(
          'addFormDebugMessage',
          'BACK CHECK | ' +
            componentIdentifier +
            ': backCheck1 is TRUE (TriumphPay), skipping Payment-1 and moving to Insurance-4'
        );
        return formRouter.moveToStepByIdentifier('Insurance-4');
        // if (renderedPayment.value?.triumph_pay_select_carrier_rate && renderedPayment.value?.is_type === 'triumph_pay') {
        //   if (Number(renderedPayment.value?.triumph_pay_select_carrier_rate) > 0) {
        //     store.commit('addFormDebugMessage', "BACK CHECK | "+componentIdentifier+": backCheck1 is TRUE (TriumphPay), skipping Payment-1 and moving to Insurance-4");
        //       return formRouter.moveToStepByIdentifier('Insurance-4');
        //   }
        // } else {
        //   store.commit('addFormDebugMessage', "BACK CHECK | "+componentIdentifier+": backCheck1 is FALSE (Not TriumphPay), not skipping Payment-1");
        // }
      } else {
        store.commit(
          'addFormDebugMessage',
          'BACK CHECK | ' +
            componentIdentifier +
            ': backCheck1 is FALSE (Not TriumphPay), not skipping Payment-1'
        );
      }

      formRouter.moveToPreviousStep();
    };

    const handleEdit = async () => {
      store.commit(
        'addFormDebugMessage',
        componentIdentifier + ": 'handleEdit' called"
      );
      if (isNavigationDisabled.value)
        return console.log(
          'ERROR: ' +
            componentIdentifier +
            ': formRouter is disabled, returning'
        );
      if (
        savedPaymentTerm.value?.is_type == 'factoring' ||
        (store.state.payments?.payment_type === 'factoring' &&
          latestFactor.value?.id > 0)
      ) {
        isLoading.value = true;
        store.commit(
          'addFormDebugMessage',
          componentIdentifier +
            ': User clicked edit when viewing a saved factoring payment term, setting edit.factor to true and redirecting to Payment-4 for verification'
        );
        store.commit('payments/setEditFactor', true);
        await formRouter.moveToStepByIdentifier('Payment-4');
        isLoading.value = false;
      } else if (shouldDisplayTPay.value == true) {
        isLoading.value = true;
        store.commit(
          'addFormDebugMessage',
          componentIdentifier +
            ': User clicked edit when viewing TPay Method, setting OP Payment Method to null if previously set and redirecting to Payment-1'
        );
        store.commit('payments/setTriumphPayDeclined', true);
        store.commit(
          'addFormDebugMessage',
          'AUTO-SUBMIT | ' +
            componentIdentifier +
            ': (handleEdit) OP Payment Term previously set, setting to null'
        );
        const bodyE1 = {
          onboarding_packet: {
            payment_method_id: null,
          },
        };
        await store.dispatch('onboardingPacket/updatePacket', {
          id: onboarding_id.value,
          body: bodyE1,
          canHitNextStep: false,
        });
        await store.dispatch('payments/nullifySavedPaymentMethod');

        await formRouter.moveToStepByIdentifier('Payment-1');
        isLoading.value = false;
      } else if (savedPaymentMethod.value?.id > 0) {
        isLoading.value = true;
        store.commit(
          'addFormDebugMessage',
          componentIdentifier +
            ': User clicked edit when viewing a saved ' +
            savedPaymentMethod.value?.is_type +
            ' payment method, re-requesting CarrierAPMs from server and setting edit.payment_method to true to allow user to choose from CarrierAPMs for the OP Term'
        );
        await store.dispatch('payments/getCarrierAPMsByTerm', opTerm.value);
        store.commit('payments/setEditPaymentMethod', true);
        isLoading.value = false;
        // store.commit('addFormDebugMessage', componentIdentifier+": User attempting to edit Payment-2 but needs to complete verification, manually redirecting to Payment-4");
        // formRouter.moveToStepByIdentifier('Payment-4');
      }
    };

    const showNewPaymentMethodModal = ref(false);
    const newPaymentMethodType = computed(
      () => store.state.payments.newPaymentMethodType
    );

    const handleAddNewPaymentMethod = () => {
      store.commit(
        'addFormDebugMessage',
        componentIdentifier + ": 'handleAddNewPaymentMethod' called"
      );
      store.commit(
        'addFormDebugMessage',
        componentIdentifier +
          ": User clicked 'Add Payment Method' button, opening NewPaymentMethodType modal to request an allowed payment method is_type for the OP Term before redirecting for verification"
      );
      showNewPaymentMethodModal.value = true;
    };
    const hasManageUsers = computed(
      () =>
        store.state.users?.currentUser?.scopes?.includes('manage_users') ||
        false
    );

    const hitEmailTemplates = async () => {
      if (hasManageUsers.value) return;

      const { payment_term, payment_method, connection } =
        store.state.carriers.carrierData;
      const isDelta = payment_term.is_type === 'delta';
      const isLoadPay = payment_method.is_type === 'load_pay';
      const connectionId = connection.id;

      if (isLoadPay) {
        await store.dispatch(
          'ownership/emailForControllingManagerAndOwners',
          connectionId
        );
      } else if (isDelta && !isLoadPay) {
        await store.dispatch('ownership/emailForOwners', connectionId);
      }
    };

    const handleAddNewPaymentMethodType = async (type) => {
      store.commit(
        'addFormDebugMessage',
        componentIdentifier +
          ": 'handleAddNewPaymentMethodType' called from modal"
      );
      store.commit(
        'addFormDebugMessage',
        componentIdentifier + ': closing NewPaymentMethodType modal'
      );
      showNewPaymentMethodModal.value = false;
      await store.dispatch('payments/storeNewPaymentMethodType', type);
      store.commit(
        'addFormDebugMessage',
        componentIdentifier +
          ': User attempting to add a new payment method (' +
          newPaymentMethodType.value +
          ') when an existing allowed payment method exists for the OP Term and needs to complete verification, manually redirecting to Payment-4'
      );
      formRouter.moveToStepByIdentifier('Payment-4');
    };

    const handleCloseNewPaymentMethodModal = async () => {
      store.commit(
        'addFormDebugMessage',
        componentIdentifier +
          ': closing NewPaymentMethodType modal, setting newPaymentMethodType, payment_source, and payment_body to null'
      );
      await store.dispatch('payments/nullifyNewPaymentMethodType');
      await store.dispatch('payments/setPaymentBody', null);
      showNewPaymentMethodModal.value = false;
    };

    return {
      componentIdentifier,
      handleNext,
      handleBack,
      handleEdit,
      buttonsToDisplay,
      isButtonDisabled,
      isNavigationDisabled,
      firstTime,
      shouldDisplayTPay,
      carrierAPMs,
      carrierAPMsHaveLoaded,
      opTerm,
      stepName,
      editFactor,
      editPaymentMethod,
      carrierAPMExistsForMethodType,
      handleAddNewPaymentMethod,
      showNewPaymentMethodModal,
      handleCloseNewPaymentMethodModal,
      handleAddNewPaymentMethodType,
      carrierActivePaymentMethods,
      newPaymentMethodType,
      savedPaymentMethod,
      carrierClickedEditTPayMethod,
      paymentType,
      isLoading,
      latestFactor,
      displayLoadPay,
      isLoadPayAllowedByPaymentTerms,
    };
  },
  data() {
    return {
      latest_factor: null,
      // factorDataAvailable: true,
      default_payment_methods: ['ach', 'check'],
      shouldUpdatePaymentSourceOnceStepNameIsPayment2: false,
      // opTerm: null,
    };
  },
  computed: {
    // stepName() {
    //   return this.$store.state.formRoutes?.activeStepIdentifier;
    // },
    // opTermAPMs() {
    //   return this.opTerm?.allowed_payment_methods;
    // },
    // opTermType() {
    //   return this.opTerm?.is_type;
    // },

    displayStandard() {
      if (this.$store.getters['shouldEnableCHRFlow']) {
        const methods = this.opTerm?.allowed_payment_methods ?? [];
        return !(methods.length === 1 && methods?.[0] === 'load_pay');
      }
      return true;
    },

    possiblePaymentMethods() {
      return this.$store.state.payments?.possible_payment_methods || [];
    },
    displayedPaymentMethod() {
      return this.$store.state.payments?.displayed_payment_method;
    },
    isTriumphPayAllowed() {
      let isAllowed = false;
      this.$store.state.payments.payment_terms.forEach((term) => {
        if (term?.is_type !== 'factoring') {
          term.allowed_payment_methods.forEach((allowed) => {
            if (allowed === 'triumph_pay') {
              isAllowed = true;
            }
          });
        }
      });

      return isAllowed;
    },
    paymentTerms() {
      return [...(this.$store.state.payments?.payment_terms ?? [])];
    },
    storedPayment() {
      return this.$store.state.payments?.activePaymentMethods;
    },
    payment() {
      const selected = this.$store.state.payments.payment_source;
      const tPayMethods =
        this.activePaymentMethodsDestructured?.length > 0
          ? this.activePaymentMethodsDestructured.filter(
              (payment) => payment.is_type === 'triumph_pay'
            )
          : [];

      if (
        this.isTriumphPayAllowed &&
        tPayMethods?.length > 0 &&
        (selected === '' || selected === 'triumph_pay')
      ) {
        return tPayMethods;
      } else if (selected) {
        const matched = this.storedPayment?.find(
          (payment) => payment.is_type === selected
        );
        return matched;
      } else {
        return this.latestAllowedPaymentMethod;
      }
    },
    typesPaymentMethods() {
      return this.storedPayment.map((payment) => payment.is_type);
    },
    loading() {
      return this.$store.state.loading.isLoading;
    },
    // latestFactor() {
    //   return this.$store.state.factors.latestFactor;
    // },
    latestAllowedPaymentMethod() {
      return this.$store.state.payments?.latest_allowed_payment_method;
    },
    // opTermType() {
    //   // return this.$store.state.payments.payment_type;
    // },
    // editFactor() {
    //   return this.$store.state.payments.edit.factor;
    // },
    // editPaymentMethod() {
    //   return this.$store.state.payments.edit.payment_method;
    // },
    paymentSource() {
      return this.$store.state.payments.payment_source;
    },
    paymentTermId() {
      return this.$store.state.payments.payment_term_id;
    },
    tPayExist() {
      return this.$store.state.payments?.activePaymentMethods?.length > 0
        ? this.$store.state.payments.activePaymentMethods?.some(
            (payment) => payment?.is_type === 'triumph_pay'
          )
        : false;
    },
    allowed_payment_methods() {
      if (this.data?.allowed_payment_methods == null) {
        return null;
      }
      let apm = [...(this.data?.allowed_payment_methods ?? [])];
      let filtered = apm.filter((item) => item !== '');
      if (filtered?.length > 0) {
        return filtered;
      } else {
        return null;
      }
    },
    verifyTypes() {
      let included = false;
      const PaymentTerms = this.$store.state.payments?.payment_terms;
      // const selectedPaymentTerm = PaymentTerms?.filter(term => term?.is_type === this.$store.state.payments.payment_type)[0];
      const selectedPaymentTerm = PaymentTerms?.filter(
        (term) => term?.id === this.$store.state.payments?.payment_term_id
      )?.[0];
      const activePaymentMethods = selectedPaymentTerm?.allowed_payment_methods;

      this.storedPayment.forEach((stored) => {
        if (activePaymentMethods?.includes(stored?.is_type)) {
          included = true;
        }
      });
      return included;
    },
    activePaymentMethodsDestructured() {
      return [...(this.$store.state.payments?.activePaymentMethods ?? [])];
    },
    paymentTermsDestructured() {
      return [...(this.$store.state.payments?.payment_terms ?? [])];
    },
    paymentTermsNonFactoring() {
      return this.paymentTermsDestructured?.filter(
        (term) => term?.is_type !== 'factoring'
      );
    },
    carrierHasAPMs() {
      return this.activePaymentMethodsDestructured?.length > 0;
    },
  },
  watch: {
    stepName: async function (val) {
      if (val == 'Payment-2') {
        // if (this.opTermType === "factoring" && !this.data.factor) {
        //   if (this.latest_factor?.length > 0) {
        //     // Auto set factor_id to the id of first latest_factor and auto set payment_method_id to null
        //     const payload = {
        //       "payment_method_id": null,
        //       "factor_id": this.latest_factor?.[0]?.id
        //     }
        //     this.$store.commit('addFormDebugMessage', "UPDATING OP BODY | Payment-2: (stepName watcher) latest_factor found and factoring payment_term_id has already been set on server, setting factor_id ("+this.latest_factor?.[0]?.id+"), and payment_method_id (auto-set to null because factor_id is present)");
        //     await this.updateOnboardingPacket(payload);

        //     this.$store.commit("toggleDisabledButton", { bool: false, source: 'PaymentStepTwo #3' });
        //   } else {
        //     this.$store.commit('addFormDebugMessage', "Payment-2: (stepName watcher) No latest_factor found and factoring payment_term_id has already been set on server, showing factoring companies search box");
        //     this.$store.commit("toggleDisabledButton", { bool: true, source: 'PaymentStepTwo #5' });
        //     setTimeout(() => {
        //       const findAutoCompleteInput = document.querySelector("#factoring_companies_input");
        //       if (findAutoCompleteInput) {
        //         findAutoCompleteInput.focus();
        //       }
        //     }, 0);
        //   }
        // }
        if (
          this.$store.state.payments?.payment_type == 'delta' &&
          this.$store.state.payments?.saved_payment_method?.is_type !==
            'load_pay'
        ) {
          this.$store.commit('payments/setSavedPaymentMethod', null);
        }
        this.checkLoadPay();

        if (this.editFactor || this.editPaymentMethod) {
          this.$store.commit('toggleDisabledButton', {
            bool: true,
            source: 'PaymentStepTwo #6',
          });
        }
      }
      // if (val == "Payment-2") {
      //   // this.setDisplayedPaymentMethod();
      // }

      // if (this.shouldUpdatePaymentSourceOnceStepNameIsPayment2) {
      //   this.$store.commit('addFormDebugMessage', "Payment-2: Now on Payment-2 step, auto-initiating update rendered_payment and payment_source");
      //   this.shouldUpdatePaymentSourceOnceStepNameIsPayment2 = false;
      //   this.updatePaymentSourceOnPaymentChange();
      // }

      // if (!this.data.factor && this.latest_factor?.length > 0 && this.data.payment_term_id) {

      // }

      // if (val === "Payment-2" && this.data.factor && !this.data.payment_term_id) {
      //   let payload = {};
      //   payload.body =  {
      //     "onboarding_packet": {
      //       "payment_term_id": this.paymentTermId,
      //       "payment_method_id": null,
      //     }
      //   }
      //   this.$store.commit('addFormDebugMessage', "AUTO PACKET UPDATE | Payment-2: (stepName watcher) payment_term_id found and factor_id has already been set on server, setting payment_term_id ("+this.paymentTermId+") and payment_method_id (auto-set to null because factor_id is present)");
      //   await this.$store.dispatch("onboardingPacket/updatePacket", payload);

      //   if(!this.$store.state.payments.edit.factor){
      //     this.$store.commit("toggleDisabledButton", { bool: false, source: 'PaymentStepTwo #4' });
      //   }
      // }

      /*if (
        val === "Payment-2" &&
        ((this.data?.payment_term?.is_type === "factoring" && !this.data.factor) ||
          (this.data?.payment_term?.is_type !== "factoring" &&
            !this.data.payment_method) && !this.storedPayment?.some(payment => payment?.is_type === 'triumph_pay'))
      ){ */
      // if (
      //   val === "Payment-2" &&
      //   (this.data?.payment_term?.is_type === "factoring" && !this.data.factor)
      // ){

      //   this.$store.commit("toggleDisabledButton", { bool: true, source: 'PaymentStepTwo #5' });

      // }

      // if (val === "Payment-2" && (this.editFactor || this.editPaymentMethod)) {
      //   this.$store.commit("toggleDisabledButton", { bool: true, source: 'PaymentStepTwo #6' });
      // }

      // if (val === "Payment-2") {
      //   console.log('stepName watcher from Payment-2 running...');
      //   if((this.latestFactor?.length && this.opTermType === "factoring") || (this.latestAllowedPaymentMethod?.length && this.opTermType !== "factoring")) {
      //     this.$store.commit("firstTime/updateStepFirstTime", {
      //       step: 'Payment',
      //       value: false,
      //     });
      //   }
      // }
    },
    '$store.state.payments.saved_payment_term': {
      handler: function (val) {
        if (val?.id > 0) {
          const updatedVal = { ...val };

          if (updatedVal.is_type === 'delta') {
            //When delta, only return LoadPay as a Payment Method.
            updatedVal.allowed_payment_methods =
              updatedVal.allowed_payment_methods.filter(
                (method) => method === 'load_pay'
              );
          }

          this.opTerm = updatedVal;
        }
      },
      deep: true,
      immediate: true,
    },
    payment: function (selectedPayment) {
      if (selectedPayment) {
        this.$store.commit(
          'addFormDebugMessage',
          "Payment-2: 'payment' watcher called, updating rendered_payment with new payment value and updating payment_source"
        );
        this.$store.commit('payments/setRenderedPayment', selectedPayment);
        if (this.stepName == 'Payment-2') {
          this.updatePaymentSourceOnPaymentChange();
          this.checkLoadPay();
        } else {
          this.$store.commit(
            'addFormDebugMessage',
            'Payment-2: Not yet on Payment-2 step, waiting to update rendered_payment and payment_source'
          );
          this.shouldUpdatePaymentSourceOnceStepNameIsPayment2 = true;
        }
      }
    },
    tPayExist: function (val) {
      if (val) {
        this.$store.commit('firstTime/updateStepFirstTime', {
          step: 'Payment',
          value: false,
        });
      }
    },
    latestFactor: function (val) {
      if (val?.length && this.opTermType === 'factoring') {
        this.$store.commit('firstTime/updateStepFirstTime', {
          step: 'Payment',
          value: false,
        });
      }
    },
    latestAllowedPaymentMethod: function (val) {
      if (val.is_type == 'load_pay') return;
      if (val?.id > 0 && this.opTermType !== 'factoring') {
        this.$store.commit('firstTime/updateStepFirstTime', {
          step: 'Payment',
          value: false,
        });
      }
    },
  },
  // async mounted() {
  //   this.factorDataAvailable = false;
  //   let res = await this.$store.dispatch('factors/getLatestFactor');
  //   if ([200, 201].includes(res?.status)) {
  //     this.latest_factor = res?.data;
  //   }

  //   if (!this.data.factor && this.latest_factor?.length > 0) {
  //     let payload = {};
  //     payload.body =  {
  //       "onboarding_packet": {
  //         "payment_term_id": this.paymentTermId,
  //         "payment_method_id": null,
  //         "factor_id": this.latest_factor?.[0]?.id
  //       }
  //     }
  //     this.$store.commit('addFormDebugMessage', "AUTO PACKET UPDATE | Payment-2: (mounted) Latest factor available, auto-submitting payment_term_id ("+this.paymentTermId+"), factor_id ("+this.latest_factor?.[0]?.id+"), and payment_method (auto-set to null) to server");
  //     this.$store.dispatch("onboardingPacket/updatePacket", payload);
  //   }
  //   this.factorDataAvailable = true;

  //   if (this.stepName === "Payment-2") {
  //     this.setDisplayedPaymentMethod();
  //   }

  // },
  methods: {
    checkLoadPay() {
      const loadPay = this.$store.state.payments?.payment_terms?.some((term) =>
        term?.allowed_payment_methods?.includes('load_pay')
      );
      if (!loadPay) return;
      if (
        !this.$store.getters['shouldEnableCHRFlow'] ||
        this.$store.getters['isForeignCarrier']
      )
        return;
      if (this.$store.state.payments?.saved_payment_method) return;

      if (this.$store.state.payments?.payment_type === 'factoring') {
        this.updateNewPaymentMethodType({ target: { value: '' } });
        return;
      }

      if (!this.newPaymentMethodType) {
        this.$store.commit('toggleDisabledButton', {
          bool: true,
          source: 'PaymentStepTwo: no payment method selected',
        });
      }
    },
    updatePacketWithPaymentTermForTriumphPay() {
      this.$store.commit(
        'addFormDebugMessage',
        "Payment-2: 'updatePacketWithPaymentTermForTriumphPay' called"
      );
      this.$store.commit(
        'addFormDebugMessage',
        'Payment-2: (updatePacketWithPaymentTermForTriumphPay) setting payment_term_id to ' +
          this.$store.state.payments?.payment_term_id +
          ' and factor_id to null'
      );
      if (this.isPaymentMethodAllowed('triumph_pay')) {
        let payload = {};
        payload.body = {
          onboarding_packet: {
            payment_term_id: this.$store.state.payments?.payment_term_id,
            factor_id: null,
          },
        };
        if (!this.$store.state.payments.edit.payment_method) {
          this.$store.commit(
            'addFormDebugMessage',
            'AUTO PACKET UPDATE | Payment-2: (updatePacketWithPaymentTermForTriumphPay) setting payment_term_id to ' +
              this.$store.state.payments?.payment_term_id +
              ' and factor_id to null'
          );
          this.$store.dispatch('onboardingPacket/updatePacket', payload);
        } else {
          this.$store.commit(
            'addFormDebugMessage',
            'Payment-2: (updatePacketWithPaymentTermForTriumphPay) updated packet not sent because edit.payment_method is true'
          );
        }
      } else {
        this.$store.commit(
          'addFormDebugMessage',
          "Payment-2: (updatePacketWithPaymentTermForTriumphPay) triumph_pay payment method not allowed in any of broker's non-factoring payment terms, did not execute server call to auto-update payment_method_id and factor_id"
        );
      }
    },
    updatePaymentSourceOnPaymentChange() {
      const selected = this.$store.state.payments.payment_source;
      console.log('this is selected', selected);

      if (
        selected.length === 0 &&
        this.$store.state.users.featureFlags?.enable_chr_onboarding?.enabled &&
        this.paymentType === 'delta'
      ) {
        console.log('Bypassing unselected load_pay');
        return;
      }

      const tPayMethods =
        this.activePaymentMethodsDestructured?.length > 0
          ? this.activePaymentMethodsDestructured.filter(
              (payment) => payment.is_type === 'triumph_pay'
            )
          : [];

      if (
        this.isTriumphPayAllowed &&
        tPayMethods?.length > 0 &&
        (selected === '' || selected === 'triumph_pay')
      ) {
        this.updatePacketWithPaymentTermForTriumphPay();
        this.updatePaymentSource(tPayMethods);
      } else if (selected) {
        const matched = this.storedPayment?.find(
          (payment) => payment.is_type === selected
        );
        this.updatePaymentSource(matched);
      } else {
        this.updatePaymentSource(this.latestAllowedPaymentMethod);
      }
    },
    updatePaymentSource(value) {
      if (this.$store.payments?.payment_source !== value?.is_type) {
        this.$store.commit(
          'addFormDebugMessage',
          "Payment-2: 'updatePaymentSource' called, payment_source updated to " +
            value?.is_type
        );
        this.$store.commit('payments/setPaymentSource', value?.is_type);
      }
    },
    findElement(arr, element) {
      if (arr?.includes(element)) {
        return element;
      }
      return null;
    },
    isPaymentMethodAllowed(requestedPaymentMethod) {
      if (this.opTermAPMs?.length > 0) {
        return this.opTermAPMs?.includes(requestedPaymentMethod);
      } else {
        return false;
      }
      // return this.paymentTermsNonFactoring?.some(term => term?.allowed_payment_methods?.includes(requestedPaymentMethod));
    },
    async togglePaymentSourceLoadPay() {
      await this.$store.dispatch('payments/setPaymentBody', null);
      this.$store.commit('toggleDisabledButton', {
        bool: false,
        source: 'PaymentStepTwo #1',
      });

      await this.$store.commit('payments/setLoadPayWasDeselected', true);

      this.$store.dispatch('payments/updateNestedField', {
        path: 'payment_source',
        value: this.paymentSource?.length > 0 ? '' : 'load_pay',
      });
    },
    async togglePaymentSource(e) {
      console.log('comes here!4');
      await this.$store.dispatch('payments/setPaymentBody', null);
      this.$store.commit('toggleDisabledButton', {
        bool: false,
        source: 'PaymentStepTwo #1',
      });

      this.$store.dispatch('payments/updateNestedField', {
        path: 'payment_source',
        value: e.target.value,
      });
    },
    updateNewPaymentMethodLoadPay(e) {
      this.$store.commit('toggleDisabledButton', {
        bool: false,
        source: 'PaymentStepTwo #1.6',
      });

      if (e.target.value == '') {
        this.$store.commit('payments/setLoadPayWasDeselected', true);
      } else {
        this.$store.commit('payments/setLoadPayWasDeselected', false);
      }

      this.$store.dispatch(
        'payments/storeNewPaymentMethodType',
        e?.target?.value
      );
    },
    updateNewPaymentMethodType(e) {
      this.$store.commit('toggleDisabledButton', {
        bool: false,
        source: 'PaymentStepTwo #1.5',
      });

      this.$store.dispatch(
        'payments/storeNewPaymentMethodType',
        e?.target?.value
      );
    },
    hydrateVerification() {
      if (this.$store.state.payments.secondVerificationPayment) {
        this.$store.commit('payments/setVerificationSecond', false);
      }
    },
    toggleButton(value) {
      this.$store.commit('toggleDisabledButton', {
        bool: value,
        source: 'PaymentStepTwo #2',
      });
    },
    // is_allowed_payment_method(payment_method) {

    //   if(this.paymentTermId){
    //     const paymentTermSelected = this.paymentTerms.filter(payment => payment.id === Number(this.paymentTermId))[0];
    //     if(paymentTermSelected){
    //       return paymentTermSelected?.allowed_payment_methods?.includes(payment_method);
    //     }
    //   }

    //   if(this.opTermType){
    //     const matchedTerm = this.paymentTerms.filter(term => term.is_type === this.opTermType)[0];
    //     if(matchedTerm) {
    //       return matchedTerm?.allowed_payment_methods?.includes(payment_method);
    //     }
    //   }
    // },
    selectPaymentMethodToDisplay(option) {
      const selected = this.$store.state.payments.payment_source;
      const tPayPayments = this.storedPayment?.filter(
        (payment) => payment?.is_type === 'triumph_pay'
      );
      const existsThePayment = this.storedPayment?.some(
        (payment) => payment?.is_type === option
      );
      const latestAllowedPaymentMethod = this.latestAllowedPaymentMethod;

      if (
        option === 'triumph_pay' &&
        tPayPayments?.length > 0 &&
        !this.$store.state.payments.triumph_pay_declined
      ) {
        this.$store.commit('payments/setVerificationSecond', true);
        return true;
      }

      if (selected === option) {
        if (existsThePayment) {
          this.$store.commit('payments/setVerificationSecond', true);
          // this.toggleButton(false);
          return true;
        }
        return false;
      }

      if (
        latestAllowedPaymentMethod?.is_type === 'triumph_pay' &&
        option === 'triumph_pay' &&
        !this.$store.state.payments.triumph_pay_declined
      ) {
        return true;
      }
      if (!selected) {
        if (latestAllowedPaymentMethod?.is_type === option) {
          this.$store.commit('toggleDisabledButton', {
            bool: false,
            source: 'PaymentStepTwo #7',
          });
          return true;
        }
        return false;
      }
    },
    // setShouldDisplayTPay() {
    //   if (this.opTermAPMs?.includes('triumph_pay') && ) {
    //     this.$store.commit('payments/setShouldDisplayTPay', true);
    //   } else {
    //     this.$store.commit('payments/setShouldDisplayTPay', false);
    //   }
    // },
    setDisplayedPaymentMethod() {
      // Display the correct saved payment method by setting store.state.payments.displayed_payment_method
      let self = this;
      if (this.displayedPaymentMethod == null) {
        self.possiblePaymentMethods.some((is_type) => {
          if (self.selectPaymentMethodToDisplay(is_type) == true) {
            self.$store.commit('payments/setDisplayedPaymentMethod', is_type);
            self.$store.commit(
              'addFormDebugMessage',
              'Payment-2: (selectPaymentMethodToDisplay) displaying ' +
                is_type +
                ' payment method'
            );
            return true;
          }
        });
      }
    },
    async updateOnboardingPacket(body) {
      this.$store.dispatch('onboardingPacket/setOnboardingBody', {
        onboarding_packet: body,
      });
    },
  },
};
</script>
